/**
 * @generated SignedSource<<32b3ae488ad424ff47799dfddedff905>>
 * @relayHash a677260f6522460ec23e89ade06f95c2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5238742cfcb15eb27cee3426d90cb9cf815931bbc25bb0e8e6d904799f271752

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_timelineQuery } from './src_timelineQuery.graphql';

import isRemoveFieldOptionsEnabled_provider from '@atlassian/jira-relay-provider/src/empanada-remove-field-options.relayprovider';
import isJiraItrM4Exp3Enabled_provider from '@atlassian/jira-relay-provider/src/is-jira-itr-m4-exp-3-enabled.relayprovider';
import isJscIFCEnabled_provider from '@atlassian/jira-relay-provider/src/is-jsc-ifc-enabled.relayprovider';
import isLinkedWorkItemsTableEnabled_provider from '@atlassian/jira-relay-provider/src/is-linked-work-items-table-enabled.relayprovider';
import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isSavedListViewTechnicalChangesEnabled_provider from '@atlassian/jira-relay-provider/src/is-saved-list-view-technical-changes-enabled.relayprovider';
import isJiraSingleLineRowHeightEnabled_provider from '@atlassian/jira-relay-provider/src/is-single-line-row-height-enabled.relayprovider';
import isReparentingEnabled_provider from '@atlassian/jira-relay-provider/src/jira-list-reparenting.relayprovider';
import isNumberFieldConfigurableEnabled_provider from '@atlassian/jira-relay-provider/src/jira-number-field-configuration-enabled.relayprovider';
import isQueryByStatusFieldDirectlyEnabled_provider from '@atlassian/jira-relay-provider/src/jiv-20953-query-by-status-field-directly.relayprovider';
import isJSCAliasChangesEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-alias-changes.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isJscM2Enabled_provider from '@atlassian/jira-relay-provider/src/jsc-m2-fe-changes.relayprovider';
import isJscMergedColumnEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-merged-column.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: PreloadableConcreteRequest<src_timelineQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5238742cfcb15eb27cee3426d90cb9cf815931bbc25bb0e8e6d904799f271752",
    "metadata": {},
    "name": "src_timelineQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjscifcenabledrelayprovider": isJscIFCEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscaliaschangesrelayprovider": isJSCAliasChangesEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider": isReparentingEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscm2fechangesrelayprovider": isJscM2Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscmergedcolumnrelayprovider": isJscMergedColumnEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisjiraitrm4exp3enabledrelayprovider": isJiraItrM4Exp3Enabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiv20953querybystatusfielddirectlyrelayprovider": isQueryByStatusFieldDirectlyEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissinglelinerowheightenabledrelayprovider": isJiraSingleLineRowHeightEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcislinkedworkitemstableenabledrelayprovider": isLinkedWorkItemsTableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranumberfieldconfigurationenabledrelayprovider": isNumberFieldConfigurableEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcempanadaremovefieldoptionsrelayprovider": isRemoveFieldOptionsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcissavedlistviewtechnicalchangesenabledrelayprovider": isSavedListViewTechnicalChangesEnabled_provider
    }
  }
};

export default node;
